import React, { useEffect, useContext } from 'react';
import EditInPreview from './Preview';
import LiteSitePreview from '../LiteSitePreview';
import Loading from '../../../Loading';
import styles from './preview.scss';
import { TrackingContext } from '../../../TrackingContext';
import useIsLiteSite from '../../../helpers/useIsLiteSiteWithLoading';
import { useSetLastVisitTimestamp } from '../../../hooks/useSetLastVisitTimestamp';

const Preview: React.FC = () => {
  const { isLiteSite, loading } = useIsLiteSite();
  const { setPageChanged } = useContext(TrackingContext);
  useSetLastVisitTimestamp();
  useEffect(() => {
    setPageChanged(prevState => !prevState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <div className={styles.previewPageLoadingContainer}>
        <Loading />
      </div>
    );
  }

  return isLiteSite ? <LiteSitePreview /> : <EditInPreview />;
};

export default Preview;
